import {Component, OnInit} from '@angular/core';
import {NGXLogger} from "ngx-logger";
import {HttpClient} from "@angular/common/http";
import {SocialAuthService, SocialUser} from "angularx-social-login";
import { FacebookLoginProvider, GoogleLoginProvider } from "angularx-social-login";
import * as environment from '../../../../environments/environment';
import {UserSession, HttpOptions} from "../../../modele/authModel";
import {HttpHeaders} from "@angular/common/http";
import {OAuthUserServiceService} from "../../../services/user/o-auth-user-service.service";
import {Router} from '@angular/router';
import {UserService} from "../../../services/user.service";

@Component({
    selector: 'app-oauth2',
    templateUrl: './oauth2.component.html',
    styleUrls: ['./oauth2.component.scss']
})
export class Oauth2Component implements OnInit {

    private log_prefix = this.constructor.name+":";

    user: SocialUser;
    loggedIn: boolean = false;

    private third_party_social_media_api_twitch_redirect_uri: string = environment.environment.third_party_social_media_api_twitch_redirect_uri;
    private third_party_social_media_api_twitch_response_type: string = environment.environment.third_party_social_media_api_twitch_response_type;
    private third_party_social_media_api_twitch_scope: string = environment.environment.third_party_social_media_api_twitch_scope;
    private third_party_social_media_api_twitch_client_id: string = environment.environment.third_party_social_media_api_twitch_client_id;
    private third_party_social_media_api_twitch_url: string = environment.environment.third_party_social_media_api_twitch_url;
    private url:string;

    constructor(private logger: NGXLogger,
                private http: HttpClient,
                private socialAuthService: SocialAuthService,
                private oAuth: OAuthUserServiceService,
                private router: Router,
                private userService: UserService
    ) {
        this.url = this.third_party_social_media_api_twitch_url+"?client_id="+this.third_party_social_media_api_twitch_client_id+"&redirect_uri="+this.third_party_social_media_api_twitch_redirect_uri+"&response_type="+this.third_party_social_media_api_twitch_response_type+"&scope="+this.third_party_social_media_api_twitch_scope;
        this.autoLoginTwitchApp();
    }

    ngOnInit() {
        this.socialAuthService.authState.subscribe((user) => {
            this.user = user;
            this.loggedIn = (user != null);
            this.logger.info(this.log_prefix," got informed of social auth'ed user:",user,"::",this.loggedIn);
            this.oAuth.updateOAuthSessionState(user).subscribe(newSocialMediaSessionState => {
                this.logger.info(this.log_prefix,"switching from [",this.loggedIn,"] to [",newSocialMediaSessionState,"]");
                this.loggedIn = newSocialMediaSessionState;
                if(this.loggedIn == true){
                    this.userService.registerAndLogInWithOAuth(user, ()=>{}).subscribe(user_session => {
                        this.router.navigate(["/u"]);
                        this.logger.info(this.log_prefix,"got session from oauth user:",user_session);
                    })
                }
            });

        });
    }

    signInWithGoogle(): void {
        this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID);
    }

    signInWithFB(): void {
        this.socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID);
    }
    signOut(): void {
        if(this.loggedIn == true){
            this.socialAuthService.signOut();
        }
    }

    autoLoginTwitchApp():void{
        let httpOpts = new HttpOptions();
            httpOpts.headers = new HttpHeaders({
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods' : 'PUT, GET, POST, DELETE, OPTIONS',
                'Cache-Control': 'no-cache'
            });

        // this.http.get(this.url, httpOpts).subscribe(resp => {
        // }, error => {
        // })
    }
}
